import React, { useEffect, useState } from 'react';
import { useBreadcrumbs } from '../hooks';
import { Header, Table, Groupper, Input, Pagination } from 'react-frontier';
import { Link } from 'react-router-dom';
import moment from 'moment';
import API from '../API';

const PAGE_SIZE = 20;

interface EmployedUser{
	user_id: number,
	first_name: string,
	last_name: string,
	email: string,
	date_created: number,
	employment_count: number,
}

var EmploymentUsers = ()=>{
	var { setTitle } = useBreadcrumbs();
	var [loadError, setLoadError] = useState<string>(null);
	var [users, setUsers] = useState<EmployedUser[]>(null);
	var [filter, setFilter] = useState<string>('');
	var [searchTimeout, setSearchTimeout] = useState<any>(null);
	var [searching, setSearching] = useState<boolean>(false);
	var [page, setPage] = useState<number>(0);

	useEffect(()=>{
		setTitle('Empleados');
		get();
	}, []);

	var get = (query?: string)=>{
		setSearching(true);
		API.getCheckinUsers(200, 0, query).then(res=>{
			if(res.error) return setLoadError(res.message);
			setLoadError(null);
			setUsers(res.data);
		}).catch(()=>{
			setLoadError('Hubo un error cargando la lista de usuarios (LCL-1)');
		}).finally(()=>{
			setSearching(false);
		});
	};

	var search = (val: string)=>{
		setPage(0);
		get(val.trim() || null);
	};

	var onSearchChange = (val: string)=>{
		setFilter(val);
		if(searchTimeout) clearTimeout(searchTimeout);
		setSearchTimeout(setTimeout(()=> search(val), 500));
	};

	var onSearchEnter = ()=>{
		if(searchTimeout) clearTimeout(searchTimeout);
		search(filter);
	};

	if(loadError) return <Header text='Error' subtext={loadError} />
	if(!users) return <Header text='Cargando datos' loading/>

	var shown_users = users.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);
	var hasNext = (page + 1) * PAGE_SIZE < users.length;

	return <div>
		<Groupper title={'Empleados'} width={950} style={{ marginTop: 20 }}>
			<Input
				placeholder='Buscar...'
				value={filter}
				onChange={onSearchChange}
				onKeyUp={ev=>{ if(ev.key === 'Enter') onSearchEnter(); }}
			/>
			<Table striped fitted selectable
				headers={['ID', 'Nombre', 'Apellido', 'Email', 'Empleos', 'Creación']}
				className='first last'
				style={{ marginTop: 20 }}
				footer={(hasNext || page !== 0) && (
					<Table.Cell colSpan={6} row>
						<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
							<Pagination page={page} onPageChange={setPage} hasNext={hasNext} />
						</div>
					</Table.Cell>
				)}
			>
				{searching ? (
					<Table.Cell row className='empty' colSpan={6}>
						<Header loading text='Cargando datos' />
					</Table.Cell>
				) : (
					shown_users.length !== 0 ? (
						shown_users.map(u => (
							<Table.Row
								collapsingIndexes={[0, 1, 2, 4, 5]}
								compact
								key={u.user_id}
								as={Link}
								to={`/employees/users/${u.user_id}`}
								data={[
									u.user_id,
									u.first_name,
									u.last_name,
									u.email,
									u.employment_count,
									moment.unix(u.date_created).format('DD/MM/YY HH:mm')
								]}
							/>
						))
					) : (
						<Table.Cell row className='empty' colSpan={6}>
							No se encontraron registros
						</Table.Cell>
					)
				)}
			</Table>
		</Groupper>
	</div>
}

export default EmploymentUsers;
